import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { routerPropTypes } from 'Types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import get from 'lodash/get'
import { storeProductsResponse, storeLocation } from 'Actions'
import { useQuery } from '@apollo/client'
import {
  Large,
  Small,
  Loading,
  MobileFilters,
  HelmetTitle
} from '../components'
import { generateQueryVars } from '../queries'
import { GET_PRODUCTS } from 'Queries'
import {
  AmplitudeEvent,
  ErrorView,
  JourneyTracker,
  FilterReduxHandler,
  LoadMoreButton,
  Progress
} from 'Blocks'
import { SCREEN_TYPE, PAGE_CONTEXT as p } from 'Constants'
import config from 'Config'

const ProductListPage = props => {
  const [currentScrollY, setCurrentScrollY] = useState(null)
  const size = parseInt(config.pagination.productList)
  const isSmall = props.screenType === SCREEN_TYPE.SMALL
  const isSearch = props.match.params.subCategory === 'search'
  const queryString = props.location.search
  const dialogViewMatch = queryString.match(/dialogView=(\w+)/)
  const dialogView = dialogViewMatch && dialogViewMatch[1] !== 'search'

  function amplitudeProps(data) {
    const categoryId = get(data, 'products.categories.current.uuid', '')
    const categoryPath =
      props.breadcrumbs.length > 0
        ? props.breadcrumbs.map(c => c.name).join(' > ')
        : get(data, 'products.categories.current.name', '')
    return {
      'Category UUID': categoryId,
      'Category Path': categoryPath
    }
  }

  function generateJourneyTrackerProps(data, isSearch) {
    const resolveBreadCrumbsName = (name, isSearch) =>
      isSearch ? 'Browse' : name
    return {
      routeName: p.PRODUCT_LIST,
      location: props.location,
      params: props.match.params,
      name: resolveBreadCrumbsName(
        data.products.categories.current.name,
        isSearch
      ),
      extra: {
        topCategories: data.products.categories.top,
        subCategories: data.products.categories.children
      }
    }
  }
  const variables = generateQueryVars(props.location, props.match.params)
  const { data, loading, error, fetchMore } = useQuery(GET_PRODUCTS, {
    variables,
    notifyOnNetworkStatusChange: true
  })

  const products = get(data, 'products.products', [])

  useEffect(() => {
    if (currentScrollY && products.length > size) {
      window.scroll(0, currentScrollY)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (loading && products.length < size) {
    if (isSmall && dialogView) {
      return (
        <MobileFilters
          data={data}
          queryString={queryString}
          loading={loading}
        />
      )
    }
    return <Loading pageName={p.PRODUCT_LIST} />
  }

  if (error) return <ErrorView message={error.message} error={error} />

  const hasMore = !!data.products.pagination.next
  const page = parseInt(data.products.pagination.next - 1)
  const currentCount = size * page
  const totalCount = data.products.aggregations.count
  const categoryName = get(data, 'products.categories.current.name', '')

  return (
    <div className={`main-container ${props.className}`}>
      <HelmetTitle {...{ categoryName }} />
      <AmplitudeEvent
        eventType={config.amplitude.types.pageView.productList}
        eventProps={amplitudeProps(data)}
      />
      <JourneyTracker {...generateJourneyTrackerProps(data, isSearch)} />
      <FilterReduxHandler
        data={data}
        url={props.location.pathname}
        queryString={queryString}
      />

      {isSmall ? (
        dialogView ? (
          <MobileFilters
            screenType={props.screenType}
            data={data}
            queryString={queryString}
          />
        ) : (
          <Small
            dialog={{
              isActive: false,
              activeView: null
            }}
            params={props.match.params}
            closeDialog={() => {}}
            location={props.location}
            data={data}
          />
        )
      ) : (
        <Large params={props.match.params} data={data} {...props} />
      )}


      {data.products && hasMore && (
        <div className="progress-status">
          <Progress
            showLabel
            max={totalCount}
            value={currentCount}
            label={
              config.locale === 'de'
                ? `${currentCount} von ${totalCount} Artikeln zeigen`
                : ''
            }
          />
          <LoadMoreButton
            onClick={() => {
              setCurrentScrollY(window.scrollY)
              fetchMore({
                variables: {
                  pagination: {
                    page: data.products.pagination.next,
                    size
                  }
                }
              })
            }}
            isLoadingMore={loading}
            useLoader
          />
        </div>
      )}
    </div>
  )
}

ProductListPage.propTypes = {
  breadcrumbs: PropTypes.array,
  className: PropTypes.string,
  screenType: PropTypes.any,
  ...routerPropTypes
}

const mapStateToProps = state => ({
  screenType: state.UI.screenType,
  breadcrumbs: state.journey.track.items
})

const mapDispatchToProps = dispatch => ({
  storeProductsResponse: bindActionCreators(storeProductsResponse, dispatch),
  storeLocation: bindActionCreators(storeLocation, dispatch),
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductListPage)
